import HttpBaseService from '@/services/http/HttpBaseService'

class WayfindingService extends HttpBaseService {

  getTravelOptions = (payload) => {
    return this.executeRequest('/api/wayfinding/estimate', 'POST', payload)
  }

}

export default new WayfindingService()
